import React, { useState } from "react";
import clsx from "clsx";
import {
  TableRow,
  TableCell,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import moment from "moment-jalaali";

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  tableCellFirst: {
    minWidth: "150px",
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  createIconContainer: {
    background: "transparent",
    color: theme.palette.secondary.main,
    width: "35px",
    height: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  tableActionContainer: {
    direction: "rtl",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    fontSize: "16px",
  },
}));

const ParticipantsTableItem = ({ data }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  return (
    <React.Fragment>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data?.owner?.fullName}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data?.rightAnswer
            ? "✅"
            : data.currentTry < 6
            ? "در حال پاسخگویی"
            : "❌"}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {moment(data.createdAt).format("jYYYY/jMM/jDD")}
        </TableCell>

        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data?.eventId?.title}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          <Button variant="outlined" color="primary" onClick={handleDialogOpen}>
            نمایش تلاش‌ها
          </Button>
        </TableCell>
      </TableRow>
      <Dialog open={open} onClose={handleDialogClose} maxWidth="sm" fullWidth>
        <DialogTitle>تلاش‌های کاربر</DialogTitle>
        <DialogContent dividers>
          <Box className={classes.textContainer}>
            <p>
              <strong>تلاش اول:</strong> {data?.try1Word}
            </p>
            <p>
              <strong>تلاش دوم:</strong> {data?.try2Word}
            </p>
            <p>
              <strong>تلاش سوم:</strong> {data?.try3Word}
            </p>
            <p>
              <strong>تلاش چهارم:</strong> {data?.try4Word}
            </p>
            <p>
              <strong>تلاش پنجم:</strong> {data?.try5Word}
            </p>
            <p>
              <strong>تلاش ششم:</strong> {data?.try6Word}
            </p>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            بستن
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ParticipantsTableItem;
